var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 197,
    viewBox: "0 0 208 197",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.03 149.885c-2.7 1.631-2.713 4.248 0 5.865l64.55 39.038a10.38 10.38 0 0 0 9.736 0l97.708-58.673c2.635-1.617 2.635-4.248 0-5.865l-64.55-39.038a10.38 10.38 0 0 0-9.736 0L32.03 149.885",
    fill: "#E5F2F5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.464 53.732c-2.55 1.463-3.732 5.294-2.6 8.554l26.76 78.663c1.12 3.261 4.081 4.724 6.619 3.261l92.286-53.1c2.489-1.462 3.733-5.293 2.6-8.566l-26.772-78.65C104.249.632 101.289-.819 98.738.644L6.464 53.732z",
    fill: "#160C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.864 62.286 2.097 6.163 24.676 72.5c1.107 3.261 4.068 4.724 6.618 3.249L129.53 91.11c2.489-1.463 3.733-5.294 2.6-8.555L105.357 3.893c-1.108-3.26-4.08-4.711-6.619-3.248L6.464 53.732c-2.55 1.463-3.732 5.306-2.6 8.554z",
    stroke: "#0E1D31",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.464 53.732 98.738.645a4.054 4.054 0 0 1 2.14-.57L97.444 0a4.17 4.17 0 0 0-2.14.57L3.032 53.658C.48 55.12-.702 58.964.43 62.212l26.76 78.663a5.12 5.12 0 0 0 4.49 3.831l3.435.074a5.145 5.145 0 0 1-4.492-3.83L4.782 64.983l-.918-2.698c-1.107-3.26.05-7.091 2.6-8.554z",
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    fill: "#FFF",
    d: "m8.47 60.29 92.647-53.31 26.4 77.585-92.648 53.297z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.681 143.23c-2.55 1.463-2.563 3.844 0 5.307l60.96 35.32a10.183 10.183 0 0 0 9.194 0l92.274-53.099c2.488-1.463 2.488-3.83 0-5.294l-60.96-35.32a10.158 10.158 0 0 0-9.182 0L37.681 143.23",
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8 147.894a.533.533 0 0 0 0 1.017l27.182 15.745c.556.278 1.211.278 1.767 0l85.344-49.108a.533.533 0 0 0 0-1.004L139.898 98.8a1.91 1.91 0 0 0-1.755 0L52.8 147.894z",
    fill: "#FFF",
    stroke: "#0E1D31",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.644 148.537 60.96 35.308a10.146 10.146 0 0 0 9.194 0l92.286-53.1A3.224 3.224 0 0 0 202 128.08v5.059a3.249 3.249 0 0 1-1.916 2.665l-92.249 53.1a10.183 10.183 0 0 1-9.194 0l-60.96-35.322a3.2 3.2 0 0 1-1.879-2.628v-5.058a3.236 3.236 0 0 0 1.842 2.64z",
    stroke: "#223056",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.757 153.297 41.404-23.816a3.869 3.869 0 0 1 3.52 0l21.262 12.311a1.079 1.079 0 0 1 0 2.033l-41.403 23.816a3.869 3.869 0 0 1-3.521 0l-21.262-12.31c-.97-.558-.97-1.463 0-2.034",
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fillOpacity: 0.232,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.44 144.47 85.356-49.107a1.984 1.984 0 0 1 1.754 0l1.754 1.017a.533.533 0 0 1 0 1.016l-85.356 49.107a1.934 1.934 0 0 1-1.767 0l-1.742-1.016a.533.533 0 0 1 0-1.017",
    stroke: "#0E1D31",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#9FA5AD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1,4",
    d: "m44.5 97.5 48-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.578 40.5c1.638 0 3.11.892 4.18 2.302 1.113 1.468 1.795 3.496 1.795 5.734 0 2.13-.618 4.072-1.639 5.52l-.748 1.062 1.267-.287a8.257 8.257 0 0 1 1.823-.203c2.154 0 4.157.837 5.84 2.268 1.682 1.43 3.044 3.45 3.928 5.833L91.065 74.252a18.785 18.785 0 0 1-.697-5.113c0-4.796 1.748-9.058 4.465-11.712.423-.413.884-.801 1.379-1.162a4.567 4.567 0 0 1-1.719.305c-1.62-.03-3.073-.933-4.127-2.342-1.094-1.464-1.764-3.476-1.764-5.692 0-2.238.682-4.266 1.795-5.734 1.07-1.41 2.542-2.302 4.18-2.302z",
    stroke: "#0E1D31",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#0E1D31",
    fill: "#E6E8EA",
    cx: 91.059,
    cy: 72,
    rx: 4.441,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#0E1D31",
    fill: "#E6E8EA",
    cx: 69.059,
    cy: 84,
    rx: 4.441,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#0E1D31",
    fill: "#0086A0",
    cx: 44.059,
    cy: 98,
    rx: 4.441,
    ry: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M42.5 98.667 44.092 100l1.239-4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.41e962ec.svg";
export { ForwardRef as ReactComponent };